<app-base-list-page
  [headersList]="headersTextList"
  (rowClick)="courseParticipantClicked($event)"
  [logHeaderList]="logHeaderList"
  [filterLists]="filterLists"
  [createNew]="createNewCourseParticipant"
  [confirmSelected]="confirmSelected"
  [switchDataToggle]="switchDataInList"
  [newItemLabel]="'Ny tilmelding'"
  #baseListPage
>
</app-base-list-page>
